import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private messageSource = new Subject<any>();
  private isListenerAdded = false;

  constructor(private ngZone: NgZone) {}

  sendMessage(message: any) {
    window.parent.postMessage(message, '*');
  }

  receiveMessage(): Observable<any> {
    if (!this.isListenerAdded) {
      this.isListenerAdded = true;

      window.addEventListener('message', (event) => {
        this.ngZone.run(() => {
          this.messageSource.next(event.data);
        });
      });
    }

    return this.messageSource.asObservable();
  }
}
